import React, {
  startTransition,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import HeaderController from "./HeaderController";
import classes from "./TableArea.module.scss";
import TableSortLabel from "@mui/material/TableSortLabel";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import CustomTablePagination from "./atoms/CustomTablePagination";
import { useLocation } from "react-router-dom";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { ApplyFormExisting } from "./modal/ApplyFormFromExisting";
import { Box, Button, Checkbox, IconButton, Tooltip } from "@mui/material";
import { foreColor, foreColorCodePagination } from "../../commons/colors";
import { useRecoilState, useRecoilValue } from "recoil";
import { userState } from "../../states/userState";
import { hasMoreState } from "../../states/hasMoreState";
import TextInputWithNoSearch from "./atoms/textFields/TextInputWithNoSearch";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import SortDrawing from "./modal/SortDrawing";
function fuzzySearch(keyword, filteredArray) {
  // Convert the keyword to lowercase for case-insensitive search
  const lowerCaseKeyword = keyword.toLowerCase();

  // Filter the array using the keyword
  const filteredResults = filteredArray.filter((item) => {
    // Check each property of the object to see if the keyword is included
    return Object.values(item).some((value) => {
      // Convert the value to a string and to lowercase for case-insensitive comparison
      const lowerCaseValue = String(value).toLowerCase();
      return lowerCaseValue.includes(lowerCaseKeyword);
    });
  });

  return filteredResults;
}

const TableArea = () => {
  const user = useRecoilValue(userState);
  const search = useLocation().search;
  const query = new URLSearchParams(search);
  const [kintoneArray, setKintoneArray] = useState([]);
  const [filteredArray, setfilteredArray] = useState([]);
  const [rows, setRows] = useState([]);
  const [targetRow, setTargetRow] = useState(null);
  // ページネーションの状態
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageForTable, setCurrentPageForTable] = useState(0);
  const [countsPerPage, setCountsPerPage] = useState(20);
  const [isShowApplyForm, setIsShowApplyForm] = useState(false);
  //テーブル参照
  const tableRef = useRef(null);
  const [hasMore, setHasMore] = useRecoilState(hasMoreState);
  const [keywords, setKeywords] = useState("");
  // チェックボックス状態管理
  const [selectedMap, setSelectedMap] = useState(new Map());
  const [selectAll, setSelectAll] = useState(false);
  const [isShowDrawSorting, setIsShowDrawSorting] = useState(false);
  const [targetDrawingList, setTargetDrawingList] = useState([]);

  const columns = [
    createColumn("checkbox", "", "left", "80px"),
    createColumn("edit", "", "left", "80px"),
    createColumn("製番", "製番", "left", "140px"),
    createColumn("製作工場", "製作工場", "left", "120px"),
    createColumn("現場名", "現場名", "left", "380px"),
    createColumn("品目", "品目", "left", "280px"),
    createColumn("品名", "品名", "left", "280px"),
    createColumn("タブ名図面名", "図面名", "left", "140px"),
    createColumn("文書名", "文書名", "left", "140px"),
    createColumn("最新フラグ", "最新", "left", "120px"),
    createColumn("コメント", "コメント", "left", "240px"),
    createColumn("備考", "備考", "left", "180px"),
    createColumn("検査", "検査", "left", "100px"),
    createColumn("検査日", "検査日", "left", "100px"),
    createColumn("図面更新日", "図面更新日", "left", "130px"),
  ];

  const [editIndex, setEditIndex] = useState(0);

  //表示行設定
  useEffect(() => {
    // 配列の長さに基づいて最大ページ数を計算
    const maxPages =
      filteredArray.length > 0
        ? Math.ceil(filteredArray.length / countsPerPage)
        : 1;

    // 現在のページが最大ページ数を超えているかどうかをチェック
    let newCurrentPage = currentPage;
    if (currentPage > maxPages) {
      newCurrentPage = maxPages; // 最後のページに設定
    } else if (currentPage < 1) {
      newCurrentPage = 1; // 最初のページに設定（念のため）
    }

    // 新しい現在のページを設定
    setCurrentPage(newCurrentPage);

    // テーブル表示用のページ計算（0から始まるインデックスのため、-1をする）
    setCurrentPageForTable(newCurrentPage - 1);

    // 新しいページ範囲に基づいて表示する行を計算
    const indexOfLastOrder = newCurrentPage * countsPerPage;
    const indexOfFirstOrder = indexOfLastOrder - countsPerPage;
    setRows(filteredArray.slice(indexOfFirstOrder, indexOfLastOrder));

    // ページが変わったらチェックボックスの状態をリセット
    setSelectedMap(new Map());
    setSelectAll(false);
  }, [filteredArray]);

  useEffect(() => {
    const indexOfLastOrder = currentPage * countsPerPage;
    const indexOfFirstOrder = indexOfLastOrder - countsPerPage;
    setRows(filteredArray.slice(indexOfFirstOrder, indexOfLastOrder));

    // ページが変わったらチェックボックスの状態をリセット
    setSelectedMap(new Map());
    setSelectAll(false);
  }, [currentPage, currentPageForTable, countsPerPage]);

  // ページ切り替えのハンドラー
  const handleChangePage = (event, newPage) => {
    if (tableRef.current) {
      tableRef.current.scrollTo({
        top: 0,
        left: 0,
      });
    }
    setCurrentPage(newPage + 1);
    setCurrentPageForTable(newPage);
  };

  //表示数切り替えハンドラー
  const handleChangeRowsPerPage = (event) => {
    if (tableRef.current) {
      tableRef.current.scrollTo({
        top: 0,
        left: 0,
      });
    }
    setCountsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
    setCurrentPageForTable(0);
  };

  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("calories");

  function createColumn(id, label, align, width) {
    return { id, label, align, width };
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);

    const sortedArray = sortfilteredArray(
      filteredArray,
      property,
      isAsc ? "desc" : "asc"
    );

    setfilteredArray(sortedArray);

    // ソート後にページネーションを適用
    const indexOfLastOrder = currentPage * countsPerPage;
    const indexOfFirstOrder = indexOfLastOrder - countsPerPage;
    setRows(sortedArray.slice(indexOfFirstOrder, indexOfLastOrder));
  };

  const createSortHandler = (property) => (event) => {
    if (property !== "checkbox") {
      handleRequestSort(event, property);
    }
  };

  function sortfilteredArray(arr, propertyName, order = "asc") {
    const arrCopy = [...arr];
    return arrCopy.sort((a, b) => {
      // プロパティが数値か文字列かによって比較方法を変える
      let valA = a[propertyName];
      let valB = b[propertyName];

      // 文字列の場合、大文字小文字を無視するために小文字に変換
      if (typeof valA === "string") valA = valA.toLowerCase();
      if (typeof valB === "string") valB = valB.toLowerCase();

      if (order === "asc") {
        return valA < valB ? -1 : valA > valB ? 1 : 0;
      } else if (order === "desc") {
        return valA > valB ? -1 : valA < valB ? 1 : 0;
      } else {
        throw new Error('Invalid sort order. Use "asc" or "desc".');
      }
    });
  }

  const StyledTableCell = styled(TableCell)(({ theme, width }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#202226",
      color: "#09A0F2",
      border: 0,
      fontSize: "12px",
      minWidth: width,
      cursor: "pointer",
      "&:hover": {
        color: "#ff0", // ホバー時のフォントカラーを黄色に変更
      },
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: "14px",
      border: 0,
      color: "inherit",
      minWidth: width,
      maxWidth: 0, // maxWidthを設定しておくことで、overflowが発生しやすくなる
      whiteSpace: "nowrap", // テキストを折り返さずに一行で表示
      overflow: "hidden", // コンテンツがオーバーフローした場合に非表示にする
      textOverflow: "ellipsis", // オーバーフローしたテキストを省略記号で表示
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "#F5F5F5",
      color: "black",
      border: 0,
      "& a": {
        color: "#09A0F2", // 偶数行のリンクの色
        "&:hover": {
          color: "#ff0", // ホバー時のフォントカラーを黄色に変更
        },
      },
      "& svg": {
        color: "#09A0F2", // 偶数行のアイコンボタンの色
        "&:hover": {
          color: "#ff0", // ホバー時のフォントカラーを黄色に変更
        },
      },
    },
    "&:nth-of-type(even)": {
      backgroundColor: "#babcc0",
      border: 0,
      "& a": {
        color: "#0444aa", // 奇数行のリンクの色
        "&:hover": {
          color: "#ff0", // ホバー時のフォントカラーを黄色に変更
        },
      },
      "& svg": {
        color: "#0444aa", // 偶数行のアイコンボタンの色
        "&:hover": {
          color: "#ff0", // ホバー時のフォントカラーを黄色に変更
        },
      },
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const handleEditIconClick = useCallback((row) => {
    setTargetRow(row);
    setIsShowApplyForm(true);
  }, []);
  const sortedRows = useMemo(() => {
    // ソート前にスプレッド演算子でコピーし、安定ソート
    const copied = [...rows];
    copied.sort((a, b) => {
      // orderBy, order(asc/desc)などを考慮してソート
      if (a[orderBy] === b[orderBy]) return 0;
      if (order === "asc") {
        return a[orderBy] > b[orderBy] ? 1 : -1;
      } else {
        return a[orderBy] < b[orderBy] ? 1 : -1;
      }
    });
    return copied;
  }, [rows, order, orderBy]);
  useEffect(() => {
    let newArray;
    if (user.filters.latestOnly) {
      newArray = kintoneArray.filter((row) => row["最新フラグ"] === "1");
    } else {
      newArray = [...kintoneArray];
    }
    if (keywords) {
      const searchResults = fuzzySearch(keywords, newArray);
      setfilteredArray(searchResults);
    } else {
      setfilteredArray(newArray);
    }
  }, [kintoneArray, user.filters.latestOnly, keywords]);

  // 個別行のチェックボックス操作
  const handleRowCheckboxChange = useCallback((recordNo) => {
    // 先にチェックを更新しつつ、重い処理は並行して実行
    startTransition(() => {
      setSelectedMap((prev) => {
        const newSelected = new Map(prev);
        newSelected.has(recordNo)
          ? newSelected.delete(recordNo)
          : newSelected.set(recordNo, true);
        return newSelected;
      });
    });
  }, []);

  // 全選択チェックボックス操作
  const handleSelectAllClick = () => {
    setSelectAll(!selectAll);
    setSelectedMap(
      new Map(selectAll ? [] : rows.map((row) => [row["レコード番号"], true]))
    );
  };

  // 「結合」ボタンのクリックハンドラ
  const handleCombineClick = () => {
    // 選択された行のデータを抽出
    const selectedRows = rows.filter((row) =>
      selectedMap.has(row["レコード番号"])
    );
    setTargetDrawingList(
      selectedRows.map((row) => {
        return {
          id: row["レコード番号"],
          drawingName: row["タブ名図面名"],
          documentName: row["文書名"],
          productNo: row["製番"],
          url: row["URL"],
          facotryName: row["製作工場"],
        };
      })
    );
    setIsShowDrawSorting(true);
  };
  useEffect(() => {
    console.log("rows");
  }, [rows, handleRowCheckboxChange, handleEditIconClick]);

  return (
    <div className={classes.rootContainer}>
      <div className={classes.controller}>
        <HeaderController
          setHasMore={setHasMore}
          setKintoneArray={setKintoneArray}
        />
        {/* ページネーション */}
        <div className={classes.pagenation}>
          {hasMore && (
            <p
              className={classes.hasMore}
              style={{ color: user?.mode === "lite" ? "#f10052" : "#fb577b" }}
            >
              1万件以上のデータがあります
            </p>
          )}
          <CustomTablePagination
            component="div"
            count={filteredArray.length}
            page={currentPageForTable}
            onPageChange={handleChangePage}
            rowsPerPage={countsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[20, 50, 100]}
            setKintoneArray={setKintoneArray}
            setKeywords={setKeywords}
            keywords={keywords}
          />
        </div>
      </div>
      <div className={classes.table}>
        <StyledTableContainer component={Paper} ref={tableRef}>
          <Table sx={{ minWidth: 650 }} stickyHeader aria-label="simple table">
            <TableHead>
              <TableRow>
                {columns.map((column) => {
                  if (column.id === "checkbox") {
                    return (
                      <StyledTableCell
                        key={column.id}
                        align={column.align}
                        width={column.width}
                        sx={{
                          backgroundColor: "#202226",
                          color: "#7ADBFF",
                          padding: "0px 4px",
                          height: "32px",
                        }}
                      >
                        <div className={classes.checkboxHeader}>
                          <Checkbox
                            checked={selectAll}
                            onChange={handleSelectAllClick}
                            sx={{
                              color: "#7ADBFF",
                              "&.Mui-checked": {
                                color: "#7ADBFF",
                              },
                              padding: "0px",
                              height: "24px",
                            }}
                            size="small"
                          />
                          <Button
                            variant="contained"
                            size="small"
                            onClick={handleCombineClick}
                            disabled={selectedMap.size === 0}
                            sx={{
                              backgroundColor: "#f25309",
                              color: "#FFFFFF",
                              fontSize: "11px",
                              padding: "4px 4px",
                              minWidth: "60px",
                              height: "30px",
                              "&:hover": {
                                backgroundColor: "#f87234",
                              },
                              "&.Mui-disabled": {
                                backgroundColor: "#37393F",
                                color: "#707070",
                              },
                            }}
                          >
                            <PictureAsPdfIcon />
                            結合
                          </Button>
                        </div>
                      </StyledTableCell>
                    );
                  }
                  if (column.id === "edit") {
                    return (
                      <StyledTableCell
                        sx={{
                          color: "#7ADBFF",
                          "&:hover": {
                            color: "#ff0", // ホバー時の色
                          },
                        }}
                        key={column.id}
                        onClick={createSortHandler(column.id)}
                        align={column.align}
                        width={column.width}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                          }}
                        >
                          <Box
                            sx={{
                              color: "#7ADBFF",
                              "&:hover": {
                                color: "#ff0", // ホバー時の色
                              },
                            }}
                          >
                            <div>{selectedMap.size}件</div>
                          </Box>
                        </div>
                      </StyledTableCell>
                    );
                  }
                  return (
                    <StyledTableCell
                      sx={{
                        color: "#7ADBFF",
                        "&:hover": {
                          color: "#ff0", // ホバー時の色
                        },
                      }}
                      key={column.id}
                      onClick={createSortHandler(column.id)}
                      align={column.align}
                      width={column.width}
                    >
                      <div style={{ display: "flex", flexWrap: "wrap" }}>
                        <Box
                          sx={{
                            color: "#7ADBFF",
                            "&:hover": {
                              color: "#ff0", // ホバー時の色
                            },
                          }}
                        >
                          {column.label}
                        </Box>
                        <div>
                          <TableSortLabel
                            active={orderBy === column.id}
                            direction={orderBy === column.id ? order : "asc"}
                            onClick={createSortHandler(column.id)}
                            sx={{
                              "&:hover": {
                                color: "#ff0", // ホバー時の色
                              },
                              "&.Mui-active": {
                                color: "#7ADBFF", // アクティブ時の色
                              },
                              "& .MuiTableSortLabel-icon": {
                                color: "#7ADBFF !important", // アイコンの色
                              },
                            }}
                          ></TableSortLabel>
                        </div>
                      </div>
                    </StyledTableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedRows.map((row) => {
                return (
                  <TableRowMemoized
                    key={row["レコード番号"]}
                    row={row}
                    handleRowCheckboxChange={handleRowCheckboxChange}
                    handleEditIconClick={handleEditIconClick}
                    isSelected={selectedMap.has(row["レコード番号"])}
                  />
                );
              })}
            </TableBody>
          </Table>
        </StyledTableContainer>
      </div>
      {isShowApplyForm && (
        <ApplyFormExisting setIsShow={setIsShowApplyForm} data={targetRow} />
      )}
      {isShowDrawSorting && targetDrawingList.length > 0 && (
        <SortDrawing
          isShow={isShowDrawSorting}
          setIsShow={setIsShowDrawSorting}
          drawingList={targetDrawingList}
          setDrawingList={setTargetDrawingList}
        />
      )}
    </div>
  );
};

export default TableArea;

// 行コンポーネントを分離してメモ化
const StyledTableCell = styled(TableCell)(({ theme, width }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#202226",
    color: "#09A0F2",
    border: 0,
    fontSize: "12px",
    minWidth: width,
    cursor: "pointer",
    "&:hover": {
      color: "#ff0", // ホバー時のフォントカラーを黄色に変更
    },
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: "14px",
    border: 0,
    color: "inherit",
    minWidth: width,
    maxWidth: 0, // maxWidthを設定しておくことで、overflowが発生しやすくなる
    whiteSpace: "nowrap", // テキストを折り返さずに一行で表示
    overflow: "hidden", // コンテンツがオーバーフローした場合に非表示にする
    textOverflow: "ellipsis", // オーバーフローしたテキストを省略記号で表示
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#F5F5F5",
    color: "black",
    border: 0,
    "& a": {
      color: "#09A0F2", // 偶数行のリンクの色
      "&:hover": {
        color: "#ff0", // ホバー時のフォントカラーを黄色に変更
      },
    },
    "& svg": {
      color: "#09A0F2", // 偶数行のアイコンボタンの色
      "&:hover": {
        color: "#ff0", // ホバー時のフォントカラーを黄色に変更
      },
    },
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#babcc0",
    border: 0,
    "& a": {
      color: "#0444aa", // 奇数行のリンクの色
      "&:hover": {
        color: "#ff0", // ホバー時のフォントカラーを黄色に変更
      },
    },
    "& svg": {
      color: "#0444aa", // 偶数行のアイコンボタンの色
      "&:hover": {
        color: "#ff0", // ホバー時のフォントカラーを黄色に変更
      },
    },
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const TableRowMemoized = React.memo(
  ({ row, isSelected, handleRowCheckboxChange, handleEditIconClick }) => {
    return (
      <StyledTableRow
        key={row["レコード番号"]}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
        selected={isSelected}
      >
        <StyledTableCell
          padding="checkbox"
          sx={{ padding: "0px 4px", textAlign: "center" }}
        >
          <Checkbox
            disabled={!row["URL"]}
            checked={isSelected}
            onChange={() => handleRowCheckboxChange(row["レコード番号"])}
            sx={{
              color: "#09A0F2",
              "&.Mui-checked": {
                color: "#09A0F2",
              },
              padding: "0px",
              height: "24px",
            }}
            size="small"
          />
        </StyledTableCell>

        <StyledTableCell component="th" scope="row">
          <IconButton
            aria-label="insertdriveicon"
            sx={{
              textAlign: "center",
              color: "#09A0F2",
              width: 5,
              "&:hover": {
                color: "#ff0", // ホバー時のフォントカラーを黄色に変更
              },
            }}
            onClick={() => handleEditIconClick(row)}
          >
            <InsertDriveFileIcon />
          </IconButton>
        </StyledTableCell>

        <StyledTableCell align="left">
          {row["URL"] ? (
            <a
              href={row["URL"]}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.linkEffect}
            >
              {row["製番"]}
            </a>
          ) : (
            row["製番"]
          )}
        </StyledTableCell>
        <StyledTableCell align="left">{row["製作工場"]}</StyledTableCell>

        <StyledTableCell align="left">
          <Tooltip title={row["現場名"] ? <span>{row["現場名"]}</span> : ""}>
            <span>{row["現場名"]}</span>
          </Tooltip>
        </StyledTableCell>

        <StyledTableCell align="left">
          <Tooltip
            title={row["品目区分"] ? <span>{row["品目区分"]}</span> : ""}
          >
            <span>{row["品目区分"]}</span>
          </Tooltip>
        </StyledTableCell>

        <StyledTableCell align="left">
          <Tooltip title={row["品名"] ? <span>{row["品名"]}</span> : ""}>
            <span>{row["品名"]}</span>
          </Tooltip>
        </StyledTableCell>

        <StyledTableCell align="left">
          <Tooltip
            title={
              row["タブ名図面名"] ? <span>{row["タブ名図面名"]}</span> : ""
            }
          >
            <span>{row["タブ名図面名"]}</span>
          </Tooltip>
        </StyledTableCell>

        <StyledTableCell align="left">
          <Tooltip
            title={row["文書名"] ? <span>{row["文書名"]}</span> : ""}
            placement="top"
          >
            <span>{row["文書名"]}</span>
          </Tooltip>
        </StyledTableCell>

        <StyledTableCell align="left">{row["最新フラグ"]}</StyledTableCell>

        <StyledTableCell align="left">
          <Tooltip
            title={row["コメント"] ? <span>{row["コメント"]}</span> : ""}
            placement="top"
          >
            <span>{row["コメント"]}</span>
          </Tooltip>
        </StyledTableCell>

        <StyledTableCell align="left">
          <Tooltip
            title={row["備考"] ? <span>{row["備考"]}</span> : ""}
            placement="top"
          >
            <span>{row["備考"]}</span>
          </Tooltip>
        </StyledTableCell>

        <StyledTableCell align="left">{row["検査"]}</StyledTableCell>
        <StyledTableCell align="left">{row["検査日"]}</StyledTableCell>

        <StyledTableCell align="left">
          <Tooltip
            title={
              row["図面更新日時"] ? <span>{row["図面更新日時"]}</span> : ""
            }
          >
            <span style={{ fontSize: "12px" }}>{row["図面更新日時"]}</span>
          </Tooltip>
        </StyledTableCell>
      </StyledTableRow>
    );
  }
);

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  margin: "0px 0 0 5px",
  maxHeight: "750px",
  width: "99vw",
  overflowX: "auto",
  [theme.breakpoints.down("xl")]: {
    width: "99vw",
    maxHeight: "330px",
    overflowX: "scroll",
  },
  [theme.breakpoints.down("md")]: {
    width: "99vw",
    maxHeight: "none",
    overflowX: "scroll",
  },
  [theme.breakpoints.down("sm")]: {
    width: "99vw",
    maxHeight: "none",
    overflowX: "scroll",
  },
}));
